import Wrapper from '../components/Wrapper';
import React, { useState, useEffect } from 'react'; 
import { TiMediaPlayOutline,TiMediaFastForwardOutline } from "react-icons/ti";
import { TbKarate,TbJewishStar} from "react-icons/tb";
import { useNavigate } from 'react-router-dom'; // Import useHistory from react-router-dom
import Confetti from 'react-confetti';
import axios from 'axios';
import { API_URL } from '../components/constants';
import { useUserContext } from '../components/UserContext';
 
 interface DashboardProps{
    msisdn:string,
    bal:number,
    minBal:number,
 }

const Dashboard: React.FC<DashboardProps> = ({msisdn, bal, minBal})=>{
  useEffect(()=>{
    //console.log('msisdn in Dashboard:', msisdn);
  },[msisdn]);

  const [starsVisible, setStarsVisible] = useState<boolean[]>(Array(10).fill(false));
  const [showConfetti, setShowConfetti] = useState<boolean>(false);
  const [entryNo, setEntryNo] = useState(0);
  const navigate = useNavigate();
  const [racePosition, setRacePosition] = useState(0); 
  const [isAWin, setIsAWin] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFail, setShowFail] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const[responseDesc, setResponseDesc] = useState("");
  // const location = useLocation();
  const { defaultRace, defaultBal, setDefaultBal, defaultMinBal, setDefaultMinBal,setDefaultRace } = useUserContext();
 
  // const searchParams = new URLSearchParams(location.search);
  // var raceAmount = searchParams.get('raceAmount');

 

const redoDefaults =  async () => {
    try {
        const {data} = await axios.get(`${API_URL}/appUser`);
        //const {data} = await axios.get(`${API_URL}/user`);
       //console.log(data);
        
        setDefaultBal(data.bal);
        setDefaultMinBal(data.MinBal);
        setDefaultRace(data.current_race);
        if(data.bal === 0 && data.MinBal === 0){
          //redirect to topup
          navigate(`/topup?msg=1`);
        }
    } catch (error) {
        console.log("First load error");
        
    }
    
 }

 

useEffect(() => {
  if (defaultBal === 0 || defaultMinBal === "0") {
    redoDefaults();
  }
}, []);

  var raceAmount = defaultRace;
  if(raceAmount === 0){
    raceAmount = 50;
  }
  //rerun defaults if amounts are zero
 
  const raceAmountNum: number | undefined = raceAmount? raceAmount : undefined;

   
  const handleButtonClick = (buttonNumber: number) => {
    //Todo check if balance is enough to boot
   
   
    if (typeof raceAmountNum === 'number' && !isNaN(raceAmountNum) && typeof bal === 'number' && !isNaN(bal)) {
      const raceTotal = buttonNumber * raceAmountNum; 
    
      
      if (raceTotal <= defaultBal || raceTotal <= parseInt(defaultMinBal, 10)) {
        // Perform actions when raceAmountNum is greater than bal
        //play
        //{"id":0,"race_amount":0,"entries":0,"msisdn":"","time_in":"0001-01-01T00:00:00Z","CreatedAt":"0001-01-01T00:00:00Z","UpdatedAt":"0001-01-01T00:00:00Z"}
        // Call the async function
        //console.log("Ready to post");
        axios.post(`${API_URL}/play`, { 
          race_amount: raceAmountNum,
          total_amount:raceTotal,
          entries: buttonNumber,
          msisdn: msisdn
        })
      .then(response => {
        //console.log('Post request successful!', response.data);
        // Handle the response here
        const resData = response.data;
        setIsAWin(resData.win);
        setDefaultBal(resData.bal);
        setDefaultMinBal(resData.min_bal);
        setEntryNo(resData.entry_number);
        const rp = resData.entry_number %10;
        setRacePosition(rp);
        //console.log(resData.win);
      })
      .catch(error => {
        console.error('Error while making the post request:', error);
        // Handle errors here
      });
      }else{
        //Todo notify on inssufficient balance
        
        setShowFail(true);
        setErrorMessage('You have insufficient balance ');
      
      }
    } else {
      // Handle the case where either raceAmountNum or bal is not a valid number
    }
    const newStarsVisible: boolean[] = [...starsVisible];
    //make the start invisible
    for (let i = 0; i < 10; i++) {
      
        newStarsVisible[i] = false;
        setStarsVisible([...newStarsVisible]);
      
    }

    for (let i = 0; i < racePosition; i++) {
      setTimeout(() => {
        newStarsVisible[i] = true;
        setStarsVisible([...newStarsVisible]);
         // Set showConfetti to true when the second star becomes visible
         if (i === (racePosition -1)) {
          const eno = (entryNo + 1) % 10;
          if(eno  === 0){
            setShowConfetti(true);
          }
          
        }

      }, (i + 1) * 100);
    }
  };

  useEffect(() => {
    // Reset confetti after a delay
    if (showConfetti) {
      const timer = setTimeout(() => {
        setShowConfetti(false);
      }, 5000); // Adjust the delay as needed
      return () => clearTimeout(timer);
    }
  }, [showConfetti]);

    return (<>
        <Wrapper  msisdn={msisdn}>  
          <div>
      
            <div  className="flex justify-center mb-4">
              <div className="bg-gray-800 text-white p-2 rounded-md">
                {/* Your content */}
                Bal: <span className='text-5xl'>{defaultBal}</span><p/>
                Available: {defaultMinBal} <p/>
                RACE: <span className='text-3xl'>{defaultRace}</span><p/>
              </div>
            </div>

            <div  className="flex justify-center   overflow-x-auto">
              <div className="p-2 text-center whitespace-nowrap">
                
              {starsVisible.map((visible, index) => (
                
              <TbJewishStar
                key={index}
                className={`text-orange-400 inline-block ${index === 9 ? 'text-8xl' : 'text-2xl'} ${visible ? '' : 'hidden'}`}
                // style={{ display: 'inline-block' }} 
              />
               
            ))}
              </div>
            </div>

            <div  className="flex bg-gray-700 opacity-15 justify-center mb-2">
              <div className="p-2  text-center text-white text-9xl">
                {/* Content inside the div */}
                {racePosition}
              </div>
            </div>


            <div  className="flex justify-center mb-2">
              <div className="p-2  text-center">
              <button
                  onClick={() => handleButtonClick(1)}
                  className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-md shadow-md transition duration-300"
                >
                  <TiMediaPlayOutline/> 1 Entry
                </button>
              </div>
            </div>



            <div  className="flex justify-center mb-2">
              <div className="p-2 text-center">
              
                <button
                  onClick={() => handleButtonClick(2)}
                  className="bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded-md shadow-md transition duration-300"
                >
                  <TiMediaFastForwardOutline/> 2 Entries
                </button>
              </div>
            </div>


            <div  className="flex justify-center mb-2">
              <div className="p-2 text-center">
              
                <button
                  onClick={() => handleButtonClick(3)}
                  className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-md shadow-md transition duration-300"
                >
                  <TbKarate /> 3 Entries
                </button>
              </div>
            </div>



        
          </div>
       
          {showConfetti && <Confetti />}
          {showSuccess && (
            <div className="bg-green-500 text-white p-4 absolute top-0 justify-center mt-10 mr-10 rounded">
              {responseDesc}
            </div>
          )}
    
          {showFail && (
            <div className="bg-red-500 text-white p-4 absolute top-0 mt-10 mr-10 rounded justify-center">
              {errorMessage}
            </div>
          )}
   
        </Wrapper>
        
    </>);
}
export default Dashboard;